var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { connect } from '@/overmind';
let Handoff = class Handoff extends Vue {
    constructor() {
        super(...arguments);
        this.token = '';
    }
    mounted() {
        this.token = localStorage.getItem('auth_token_default') || '';
    }
    get handoffUrl() {
        if (window.location.hostname.match('dev')) {
            return `https://dev.atlas-handoff.speedio.com.br/closer?token=${this.token}`;
        }
        if (window.location.hostname.match('test')) {
            return `https://stg.atlas-handoff.speedio.com.br/closer?token=${this.token}`;
        }
        if (window.location.hostname.match('app')) {
            return `https://app.atlas-handoff.speedio.com.br/closer?token=${this.token}`;
        }
        if (window.location.hostname.match('staging')) {
            return `https://stg.atlas-handoff.speedio.com.br/closer?token=${this.token}`;
        }
        return `https://dev.atlas-handoff.speedio.com.br/closer?token=${this.token}`;
    }
};
Handoff = __decorate([
    Component(connect(({ actions, state }) => ({
        actions: actions.users,
        searchDefault: state.search.defaultSearch,
    }), {
        name: 'Handoff',
        components: {},
    }))
], Handoff);
export default Handoff;
